<template>
  <v-container>
    <!-- <v-layout>
      <h1>Fixed Cost #{{$route.params.id}}</h1>
    </v-layout>-->
    <v-layout justify-center py-3 row wrap>
      <v-flex xs12 md10 xl8 py-3>
        <SimpleCard>
          <ZoneMap ref="zoneMap">Fixed Cost #{{$route.params.id}}</ZoneMap>
        </SimpleCard>
      </v-flex>
      <v-flex xs12 md10 xl8 py-3>
        <SimpleCard>
          <FileInput
            label="Upload Zone File"
            icon="insert_drive_file"
            accept="*"
            :required="true"
            :multiple="false"
            @fileInput="handleDocumentInput"
          />
          <v-btn
            @click="uploadZoneFileRender"
            v-if="zoneFile != null"
            small
            class="text-none"
          >Render Zonefile</v-btn>
          <v-btn
            @click="updateZones"
            v-if="zoneFile != null"
            small
            class="text-none"
          >Save and Use Zonefile</v-btn>
        </SimpleCard>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// @ is an alias to /src
import Overview from "@/components/settings/Overview.vue";
import ZoneMap from "@/components/settings/zones/ZoneMap.vue";

import SimpleCard from "@/components/widget/SimpleCard.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

import FileInput from "@/components/widget/input/FileInput.vue";

export default {
  name: "zones",
  components: {
    Overview,
    ZoneMap,
    FileInput,
    SimpleCard
  },
  data: function() {
    return {
      fixedCost: null,
      loading: false,
      rideTypes: null,
      zones: null,
      zoneFile: null
    };
  },
  mounted: function() {
    var vm = this;

    setTimeout(vm.getZones, 1000);
  },
  methods: {
    handleDocumentInput: function(file) {
      this.zoneFile = file;
    },
    failed: function(data) {
      alert("Request Failed with error: " + data.message);
    },
    getZones: async function() {
      try {
        var url = `${this.$store.state.apiUrl}/zones/all`;

        let response = await axios.get(url, {
          params: {}
        });

        if (response.data.error == "no_error") {
          this.zones = response.data.zones;
          this.renderZones();
        }
      } catch (error) {
        console.log(error);
        this.loading = false;
        console.log("Failed to get zones");
      }
    },
    renderZones: function() {
      this.$refs.zoneMap.populatePolygons(this.zones);
    },
    uploadZoneFileRender: function(p) {
      console.log("Form Submitted");

      this.loading = true;

      var url = `${this.$store.state.apiUrl}/zones/parseZoneFile`;

      var failed = this.failed;

      var vm = this;

      axios({
        url: url,
        method: "POST",
        data: this.zoneFile,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          if (res.data.error == "no_error") {
            vm.zones = res.data.zones;
            vm.renderZones();
          } else {
            failed(res.data.error);
          }
        })
        .catch(function(err) {
          failed("internal_server_error");
          console.error(err);
        });
    },
    updateZones: function(p) {
      console.log("Form Submitted");

      this.loading = true;

      var url = `${this.$store.state.apiUrl}/zones/updateZones`;

      var failed = this.failed;

      var vm = this;

      axios({
        url: url,
        method: "POST",
        data: this.zoneFile,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          if (res.data.error == "no_error") {
            vm.zones = res.data.zones;
            vm.renderZones();
          } else {
            failed(res.data.error);
          }
        })
        .catch(function(err) {
          failed("internal_server_error");
          console.error(err);
        });
    }
  }
};
</script>
